<template>
  <div>
    <v-autocomplete
      :value="selectedTagIds"
      @input="handleInput"
      :items="availableTags"
      item-text="name"
      item-value="id"
      multiple
      chips
      outlined
      dense
      hide-details
      placeholder="พิมพ์เพื่อค้นหาชื่อ Tags"
      label="เลือก Tags"
      append-icon=""
      height="32px"
    >
      <template v-slot:selection="data">
        <v-chip
          :key="data.item.id"
          :color="data.item.color"
          text-color="white"
          close
          @click:close="removeTagFromAutocomplete(data.item.id)"
        >
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-chip
          :color="data.item.color"
          text-color="white"
          class="ma-1"
        >
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:append-outer>
        <v-btn
          icon
          color="primary"
          @click="showTagDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-autocomplete>

    <v-dialog v-model="showTagDialog" max-width="800">
      <v-card>
        <v-card-title>
          {{ editingTag ? 'แก้ไข Tag' : 'สร้าง Tag ใหม่' }}
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tagDialogTab">
            <v-tab>สร้าง Tag ใหม่</v-tab>
            <v-tab>จัดการ Tags</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tagDialogTab">
            <v-tab-item>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-text-field
                    v-model="newTagName"
                    label="กรอกชื่อ Tag"
                    outlined
                    dense
                    hide-details
                    class="mb-3"
                  ></v-text-field>
                  <div class="mb-3">
                    <label class="v-label theme--light" style="font-size: 12px; margin-bottom: 8px; display: block;">เลือกสี</label>
                    <div class="color-swatches-container">
                      <div 
                        v-for="(row, rowIndex) in customSwatches" 
                        :key="rowIndex"
                        class="color-swatch-row"
                      >
                        <div
                          v-for="(color, colorIndex) in row"
                          :key="colorIndex"
                          class="color-swatch"
                          :style="{ backgroundColor: color }"
                          :class="{ 'selected': newTagColorHex === color }"
                          @click="selectColor(color)"
                        >
                          <v-icon v-if="newTagColorHex === color" color="white">mdi-check</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-btn
                    color="primary"
                    @click="createTag"
                    :disabled="!newTagName"
                    block
                  >
                    สร้าง Tag ใหม่
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">ชื่อ Tag</th>
                          <th class="text-left">สี</th>
                          <th class="text-right">จัดการ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tag in availableTags" :key="tag.id">
                          <td>
                            <v-text-field
                              v-if="editingTag && editingTag.id === tag.id"
                              v-model="editingTag.name"
                              outlined
                              hide-details
                            ></v-text-field>
                            <span v-else>{{ tag.name }}</span>
                          </td>
                          <td width="40%">
                            <div v-if="editingTag && editingTag.id === tag.id" class="color-swatches-container mt-2">
                              <div 
                                v-for="(row, rowIndex) in customSwatches" 
                                :key="rowIndex"
                                class="color-swatch-row"
                              >
                                <div
                                  v-for="(color, colorIndex) in row"
                                  :key="colorIndex"
                                  class="color-swatch"
                                  :style="{ backgroundColor: color }"
                                  :class="{ 'selected': editingTag.color === color }"
                                  @click="editingTag.color = color"
                                >
                                  <v-icon v-if="editingTag.color === color" color="white">mdi-check</v-icon>
                                </div>
                              </div>
                            </div>
                            <v-chip
                              v-else
                              :color="tag.color"
                              text-color="white"
                            >
                              {{ tag.name }}
                            </v-chip>
                          </td>
                          <td class="text-center">
                            <div v-if="editingTag && editingTag.id === tag.id">
                              <v-btn
                                color="success"
                                @click="saveTag"
                                class="mr-2 mb-4"
                              >
                                <v-icon left>mdi-content-save</v-icon>
                                บันทึก
                              </v-btn>
                              <v-btn
                                color="grey"
                                @click="cancelEdit"
                              >
                                ยกเลิก
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                icon
                                color="primary"
                                @click="startEditTag(tag)"
                                class="mr-2"
                              >
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                color="error"
                                @click="confirmDeleteTag(tag)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" text>ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteConfirm" max-width="500">
      <v-card>
        <v-card-title>
          ยืนยันการลบ Tag
          <v-spacer></v-spacer>
          <v-btn @click="showDeleteConfirm = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p>คุณต้องการลบ Tag "{{ tagToDelete ? tagToDelete.name : '' }}" หรือไม่?</p>
          <p class="red--text mt-2">หมายเหตุ: Tag นี้จะถูกลบออกจาก Orders ทั้งหมดที่ใช้ Tag นี้</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showDeleteConfirm = false" text>ยกเลิก</v-btn>
          <v-btn @click="deleteTag" color="error" depressed>ลบ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OrderTagManager",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showTagDialog: false,
      tagDialogTab: 0,
      availableTags: [],
      selectedTagIds: [],
      newTagName: "",
      newTagColor: "#1976D2",
      newTagColorHex: "#1976D2",
      editingTag: null,
      showDeleteConfirm: false,
      tagToDelete: null,
      customSwatches: [
  // ม่วง (Purple)
  ['#2E0854', '#4B0082', '#6A0DAD', '#8E24AA', '#AB47BC'],

  // คราม (Indigo)
  ['#1A237E', '#283593', '#3949AB', '#5C6BC0', '#7986CB'],

  // น้ำเงิน (Blue)
  ['#0D1B2A', '#0B3D91', '#1565C0', '#1E88E5', '#42A5F5'],

  // เขียว (Green)
  ['#0B3D2E', '#145A32', '#1E8449', '#27AE60', '#52BE80'],

  // เหลือง (Amber / Yellow)
  ['#7D6608', '#9A7D0A', '#B7950B', '#D4AC0D', '#F4D03F'],

  // ส้ม (Orange)
  ['#7E2F00', '#A04000', '#CA6F1E', '#E67E22', '#F39C12'],

  // แดง (Red)
  ['#641E16', '#922B21', '#A93226', '#C0392B', '#EC7063'],
],
    };
  },
  watch: {
    newTagColorHex(newVal) {
      this.newTagColor = newVal;
    },
    newTagColor(newVal) {
      if (typeof newVal === 'string') {
        this.newTagColorHex = newVal;
      } else if (typeof newVal === 'object' && newVal.hex) {
        this.newTagColorHex = newVal.hex;
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (Array.isArray(newVal)) {
          // Only update if arrays are different
          const newIds = [...newVal].sort((a, b) => a - b);
          const currentIds = [...this.selectedTagIds].sort((a, b) => a - b);
          const isDifferent = newIds.length !== currentIds.length || 
            newIds.some((id, index) => id !== currentIds[index]);
          if (isDifferent) {
            this.selectedTagIds = [...newVal];
          }
        }
      },
    },
  },
  created() {
    this.getTags();
  },
  methods: {
    getTags() {
      axios
        .get("/api/orders/tags/")
        .then((res) => {
          this.availableTags = res.data.data;
        })
        .catch((e) => {
          this.$store.state.snackbar = {
            text:
              "เกิดข้อผิดพลาดในการโหลด tags : " +
              e.response.status +
              " " +
              e.response.statusText,
            visible: true,
            color: "error",
          };
        });
    },
    handleInput(newValue) {
      this.selectedTagIds = [...newValue];
      this.$emit("input", [...newValue]);
    },
    removeTagFromAutocomplete(tagId) {
      const newValue = this.selectedTagIds.filter(id => id !== tagId);
      this.handleInput(newValue);
    },
    selectColor(color) {
      this.newTagColor = color;
      this.newTagColorHex = color;
    },
    createTag() {
      if (!this.newTagName) return;
      // Use hex value directly
      const colorValue = this.newTagColorHex || this.newTagColor;
      axios
        .post("/api/orders/tags/", {
          name: this.newTagName,
          color: colorValue,
        })
        .then((res) => {
          this.availableTags.push(res.data.data);
          this.newTagName = "";
          this.newTagColor = "#1976D2";
          this.newTagColorHex = "#1976D2";
          this.closeDialog();
          this.$store.state.snackbar = {
            text: "สร้าง Tag สำเร็จ",
            visible: true,
            color: "success",
          };
        })
        .catch((e) => {
          this.$store.state.snackbar = {
            text:
              "เกิดข้อผิดพลาดในการสร้าง tag : " +
              e.response.status +
              " " +
              e.response.statusText,
            visible: true,
            color: "error",
          };
        });
    },
    closeDialog() {
      this.showTagDialog = false;
      this.tagDialogTab = 0;
      this.editingTag = null;
      this.newTagName = "";
      this.newTagColor = "#1976D2";
      this.newTagColorHex = "#1976D2";
    },
    startEditTag(tag) {
      this.editingTag = { ...tag };
    },
    cancelEdit() {
      this.editingTag = null;
    },
    saveTag() {
      if (!this.editingTag || !this.editingTag.name) return;
      axios
        .put("/api/orders/tags/", {
          id: this.editingTag.id,
          name: this.editingTag.name,
          color: this.editingTag.color,
        })
        .then((res) => {
          const index = this.availableTags.findIndex(t => t.id === this.editingTag.id);
          if (index > -1) {
            this.availableTags[index] = res.data.data;
          }
          this.editingTag = null;
          this.$store.state.snackbar = {
            text: "แก้ไข Tag สำเร็จ",
            visible: true,
            color: "success",
          };
        })
        .catch((e) => {
          this.$store.state.snackbar = {
            text:
              "เกิดข้อผิดพลาดในการแก้ไข tag : " +
              e.response.status +
              " " +
              e.response.statusText,
            visible: true,
            color: "error",
          };
        });
    },
    confirmDeleteTag(tag) {
      this.tagToDelete = tag;
      this.showDeleteConfirm = true;
    },
    deleteTag() {
      if (!this.tagToDelete) return;
      axios
        .delete("/api/orders/tags/", {
          data: { id: this.tagToDelete.id }
        })
        .then(() => {
          // Remove tag from available tags
          this.availableTags = this.availableTags.filter(t => t.id !== this.tagToDelete.id);
          // Remove tag from selected tags if it was selected
          const newSelectedIds = this.selectedTagIds.filter(id => id !== this.tagToDelete.id);
          if (newSelectedIds.length !== this.selectedTagIds.length) {
            this.handleInput(newSelectedIds);
          }
          this.showDeleteConfirm = false;
          this.tagToDelete = null;
          this.$store.state.snackbar = {
            text: "ลบ Tag สำเร็จ",
            visible: true,
            color: "success",
          };
        })
        .catch((e) => {
          this.$store.state.snackbar = {
            text:
              "เกิดข้อผิดพลาดในการลบ tag : " +
              e.response.status +
              " " +
              e.response.statusText,
            visible: true,
            color: "error",
          };
        });
    },
  },
};
</script>

<style scoped>
.color-swatches-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
}

.color-swatch-row {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

.color-swatch {
  width: 20%;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.color-swatch:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.color-swatch.selected {
  border: 3px solid #333;
  box-shadow: 0 0 0 2px white, 0 0 0 4px #333;
}
</style>

